export { default as SvgAccount } from './SvgAccount';
export { default as SvgAccountFilled } from './SvgAccountFilled';
export { default as SvgAddCircleFilled } from './SvgAddCircleFilled';
export { default as SvgAddCircle } from './SvgAddCircle';
export { default as SvgAddSquare } from './SvgAddSquare';
export { default as SvgAddSquareFilled } from './SvgAddSquareFilled';
export { default as SvgAlert } from './SvgAlert';
export { default as SvgAlertFilled } from './SvgAlertFilled';
export { default as SvgArrowUp } from './SvgArrowUp';
export { default as SvgArrowUpFilled } from './SvgArrowUpFilled';
export { default as SvgArrowRight } from './SvgArrowRight';
export { default as SvgArrowRightFilled } from './SvgArrowRightFilled';
export { default as SvgArrowDown } from './SvgArrowDown';
export { default as SvgArrowDownFilled } from './SvgArrowDownFilled';
export { default as SvgArrowLeft } from './SvgArrowLeft';
export { default as SvgArrowLeftFilled } from './SvgArrowLeftFilled';
export { default as SvgBadge } from './SvgBadge';
export { default as SvgBadgeFilled } from './SvgBadgeFilled';
export { default as SvgBookmark } from './SvgBookmark';
export { default as SvgBookmarkFilled } from './SvgBookmarkFilled';
export { default as SvgBuilding } from './SvgBuilding';
export { default as SvgBuildingFilled } from './SvgBuildingFilled';
export { default as SvgBusiness } from './SvgBusiness';
export { default as SvgBusinessFilled } from './SvgBusinessFilled';
export { default as SvgCalendar } from './SvgCalendar';
export { default as SvgCalendarFilled } from './SvgCalendarFilled';
export { default as SvgCamera } from './SvgCamera';
export { default as SvgCameraFilled } from './SvgCameraFilled';
export { default as SvgCart } from './SvgCart';
export { default as SvgCartFilled } from './SvgCartFilled';
export { default as SvgCategory } from './SvgCategory';
export { default as SvgCategoryFilled } from './SvgCategoryFilled';
export { default as SvgChallenge } from './SvgChallenge';
export { default as SvgChallengeFilled } from './SvgChallengeFilled';
export { default as SvgChefHat } from './SvgChefHat';
export { default as SvgChefHatFilled } from './SvgChefHatFilled';
export { default as SvgCloseCircle } from './SvgCloseCircle';
export { default as SvgCloseCircleFilled } from './SvgCloseCircleFilled';
export { default as SvgCoupon } from './SvgCoupon';
export { default as SvgCouponFilled } from './SvgCouponFilled';
export { default as SvgCreditCard } from './SvgCreditCard';
export { default as SvgCreditCardFilled } from './SvgCreditCardFilled';
export { default as SvgDelete } from './SvgDelete';
export { default as SvgDeleteFilled } from './SvgDeleteFilled';
export { default as SvgDeliveryBike } from './SvgDeliveryBike';
export { default as SvgDeliveryBikeFilled } from './SvgDeliveryBikeFilled';
export { default as SvgDeliveryVan } from './SvgDeliveryVan';
export { default as SvgDeliveryVanFilled } from './SvgDeliveryVanFilled';
export { default as SvgDineIn } from './SvgDineIn';
export { default as SvgDineInFilled } from './SvgDineInFilled';
export { default as SvgDislike } from './SvgDislike';
export { default as SvgDislikeFilled } from './SvgDislikeFilled';
export { default as SvgDonate } from './SvgDonate';
export { default as SvgDonateFilled } from './SvgDonateFilled';
export { default as SvgEdit } from './SvgEdit';
export { default as SvgEditFilled } from './SvgEditFilled';
export { default as SvgFavourite } from './SvgFavourite';
export { default as SvgFavouriteFilled } from './SvgFavouriteFilled';
export { default as SvgFilter } from './SvgFilter';
export { default as SvgFilterFilled } from './SvgFilterFilled';
export { default as SvgFlash } from './SvgFlash';
export { default as SvgFlashFilled } from './SvgFlashFilled';
export { default as SvgGift } from './SvgGift';
export { default as SvgGiftFilled } from './SvgGiftFilled';
export { default as SvgGlutenFree } from './SvgGlutenFree';
export { default as SvgGlutenFreeFilled } from './SvgGlutenFreeFilled';
export { default as SvgHalal } from './SvgHalal';
export { default as SvgHalalFilled } from './SvgHalalFilled';
export { default as SvgHealthierChoice } from './SvgHealthierChoice';
export { default as SvgHealthierChoiceFilled } from './SvgHealthierChoiceFilled';
export { default as SvgHelp } from './SvgHelp';
export { default as SvgHelpFilled } from './SvgHelpFilled';
export { default as SvgHide } from './SvgHide';
export { default as SvgHideFilled } from './SvgHideFilled';
export { default as SvgHome } from './SvgHome';
export { default as SvgHomeFilled } from './SvgHomeFilled';
export { default as SvgInfo } from './SvgInfo';
export { default as SvgInfoFilled } from './SvgInfoFilled';
export { default as SvgLike } from './SvgLike';
export { default as SvgLikeFilled } from './SvgLikeFilled';
export { default as SvgLinkOut } from './SvgLinkOut';
export { default as SvgLinkOutFilled } from './SvgLinkOutFilled';
export { default as SvgList } from './SvgList';
export { default as SvgListFilled } from './SvgListFilled';
export { default as SvgLocation } from './SvgLocation';
export { default as SvgLocationFilled } from './SvgLocationFilled';
export { default as SvgLocationPin } from './SvgLocationPin';
export { default as SvgLocationPinFilled } from './SvgLocationPinFilled';
export { default as SvgLogin } from './SvgLogin';
export { default as SvgLoginFilled } from './SvgLoginFilled';
export { default as SvgLogout } from './SvgLogout';
export { default as SvgLogoutFilled } from './SvgLogoutFilled';
export { default as SvgIdentity } from './SvgIdentity';
export { default as SvgIdentityFilled } from './SvgIdentityFilled';
export { default as SvgMenuHamb } from './SvgMenuHamb';
export { default as SvgMenuHambFilled } from './SvgMenuHambFilled';
export { default as SvgMinusCircle } from './SvgMinusCircle';
export { default as SvgMinusCircleFilled } from './SvgMinusCircleFilled';
export { default as SvgNoInternet } from './SvgNoInternet';
export { default as SvgNoInternetFilled } from './SvgNoInternetFilled';
export { default as SvgNotification } from './SvgNotification';
export { default as SvgNotificationFilled } from './SvgNotificationFilled';
export { default as SvgOrders } from './SvgOrders';
export { default as SvgOrdersFilled } from './SvgOrdersFilled';
export { default as SvgPot } from './SvgPot';
export { default as SvgPotFilled } from './SvgPotFilled';
export { default as SvgPromotion } from './SvgPromotion';
export { default as SvgPromotionFilled } from './SvgPromotionFilled';
export { default as SvgQrCode } from './SvgQrCode';
export { default as SvgQrCodeFilled } from './SvgQrCodeFilled';
export { default as SvgScales } from './SvgScales';
export { default as SvgScalesFilled } from './SvgScalesFilled';
export { default as SvgScan } from './SvgScan';
export { default as SvgScanFilled } from './SvgScanFilled';
export { default as SvgSearch } from './SvgSearch';
export { default as SvgSearchFilled } from './SvgSearchFilled';
export { default as SvgSettings } from './SvgSettings';
export { default as SvgSettingsFilled } from './SvgSettingsFilled';
export { default as SvgShare } from './SvgShare';
export { default as SvgShareFilled } from './SvgShareFilled';
export { default as SvgShow } from './SvgShow';
export { default as SvgShowFilled } from './SvgShowFilled';
export { default as SvgStar } from './SvgStar';
export { default as SvgStarFilled } from './SvgStarFilled';
export { default as SvgStore } from './SvgStore';
export { default as SvgStoreFilled } from './SvgStoreFilled';
export { default as SvgSuccess } from './SvgSuccess';
export { default as SvgSuccessFilled } from './SvgSuccessFilled';
export { default as SvgTakeaway } from './SvgTakeaway';
export { default as SvgTakeawayFilled } from './SvgTakeawayFilled';
export { default as SvgClock } from './SvgClock';
export { default as SvgClockFilled } from './SvgClockFilled';
export { default as SvgTips } from './SvgTips';
export { default as SvgTipsFilled } from './SvgTipsFilled';
export { default as SvgTransFatFree } from './SvgTransFatFree';
export { default as SvgTransFatFreeFilled } from './SvgTransFatFreeFilled';
export { default as SvgTrophy } from './SvgTrophy';
export { default as SvgTrophyFilled } from './SvgTrophyFilled';
export { default as SvgUser } from './SvgUser';
export { default as SvgUserFilled } from './SvgUserFilled';
export { default as SvgVegetarian } from './SvgVegetarian';
export { default as SvgVegetarianFilled } from './SvgVegetarianFilled';
export { default as SvgWhisk } from './SvgWhisk';
export { default as SvgWhiskFilled } from './SvgWhiskFilled';
export { default as SvgWine } from './SvgWine';
export { default as SvgWineFilled } from './SvgWineFilled';
export { default as SvgArrowDoubleUp } from './SvgArrowDoubleUp';
export { default as SvgArrowDoubleRight } from './SvgArrowDoubleRight';
export { default as SvgArrowDoubleDown } from './SvgArrowDoubleDown';
export { default as SvgArrowDoubleLeft } from './SvgArrowDoubleLeft';
export { default as SvgAdd } from './SvgAdd';
export { default as SvgMinus } from './SvgMinus';
export { default as SvgClose } from './SvgClose';
export { default as SvgTick } from './SvgTick';
export { default as SvgMenuMoreHorizontal } from './SvgMenuMoreHorizontal';
export { default as SvgMenuMoreVertical } from './SvgMenuMoreVertical';
export { default as SvgHistory } from './SvgHistory';
export { default as SvgLoading } from './SvgLoading';
export { default as SvgLinkPlus } from './SvgLinkPlus';
export { default as SvgLinkPoints } from './SvgLinkPoints';
export { default as SvgArrowUpward } from './SvgArrowUpward';
export { default as SvgTrendingUp } from './SvgTrendingUp';
export { default as SvgDirectionalArrowLeft } from './SvgDirectionalArrowLeft';
export { default as SvgDirectionalArrowRight } from './SvgDirectionalArrowRight';
export { default as SvgOrderNote } from './SvgOrderNote';
export { default as SvgFacebook } from './SvgFacebook';
export { default as SvgFacebookDark } from './SvgFacebookDark';
export { default as SvgFacebookWhite } from './SvgFacebookWhite';
export { default as SvgInstagram } from './SvgInstagram';
export { default as SvgInstagramDark } from './SvgInstagramDark';
export { default as SvgInstagramWhite } from './SvgInstagramWhite';
export { default as SvgApple } from './SvgApple';
export { default as SvgAppleDark } from './SvgAppleDark';
export { default as SvgAppleWhite } from './SvgAppleWhite';
export { default as SvgGoogle } from './SvgGoogle';
export { default as SvgGoogleDark } from './SvgGoogleDark';
export { default as SvgGoogleWhite } from './SvgGoogleWhite';
export { default as SvgSpotify } from './SvgSpotify';
export { default as SvgSpotifyDark } from './SvgSpotifyDark';
export { default as SvgSpotifyWhite } from './SvgSpotifyWhite';
export { default as SvgYoutube } from './SvgYoutube';
export { default as SvgYoutubeDark } from './SvgYoutubeDark';
export { default as SvgYoutubeWhite } from './SvgYoutubeWhite';
export { default as SvgBack } from './SvgBack';
export { default as SvgBackFilled } from './SvgBackFilled';
export { default as SvgCheck } from './SvgCheck';
export { default as SvgProfile } from './SvgProfile';
export { default as SvgVerified } from './SvgVerified';
//# sourceMappingURL=index.js.map